import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/help/question.png")